class CollectionHero extends HTMLElement {
  constructor() {
    super()

    this.toggleButtons = this.querySelectorAll('.js-read-toggle')
    this.toggleButtons.forEach(btn => btn.addEventListener('click', this.toggleRead.bind(this)))
    this.collapseButtons = this.querySelectorAll('.js-read-less')
  }

  toggleRead(e) {
    e.preventDefault()
    const content = this.querySelector('.js-read-content')
    content.classList.toggle('expand')
    content.focus()

    this.collapseButtons.forEach(button => {
      button.style.display = content.classList.contains('expand') ? '' : 'none'
    })
  }
}

customElements.define('collection-hero', CollectionHero)
